import { _ as _getMapData } from "./auth-service-tools1333.js";
var getMapData = _getMapData;

function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;
export { _mapCacheSet as _ };